import Response from './Response';

import { news_alerts } from 'lang/en.json';

const Responses = ({ list, status, id, alertSlug }) => {
    const dataList = [...list];

    return (
        <div>
            {dataList?.length ? (
                dataList.map((item, index) => {
                    return (
                        <Response
                            {...item}
                            status={status}
                            alertId={id}
                            alertSlug={alertSlug}
                            key={`response-${index}`}
                        />
                    );
                })
            ) : (
                <p>
                    {status === 'active'
                        ? news_alerts.responses.no_response
                        : news_alerts.responses.closed_alert}
                </p>
            )}
        </div>
    );
};

export default Responses;
